import { Component } from '@verndale/core';
import Swiper from 'swiper';


class Module extends Component {
  setupDefaults() { 
    this.dom = {
      $swiper: this.el._$('.swiper'),
      $slides: Array.from(this.el.querySelectorAll('.swiper-slide')),
    };

    this.interval = parseInt(this.el.getAttribute('data-interval'));
    if (isNaN(this.interval) || this.interval < 3000) {
      this.interval = 5000;
    }
  
    if (this.dom.$slides.length > 1) {
      this.initSlider();
    }
  }

  initSlider() {
    const swiperOptions = {
      autoHeight: false,
      slidesPerView: 1,
      slidesPerGroup: 1,
      centeredSlides: true,
      spaceBetween: 0,
      loop: true,
    };

    this.slider = new Swiper(this.dom.$swiper, swiperOptions);

    setInterval(() => {
      this.slider.slideNext();
    }, this.interval);
  }
}

export default Module;
